<template>
  <div>
    <el-dialog
      width="60rem"
      :key="2"
      :append-to-body="true"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @closed="handleDialogClosed"
    >
      <div slot="title" class="dialog_title">{{ dialog.title }}</div>
      <div class="dialog_content">
        <el-form
          :model="dialog.elForm"
          :rules="dialog.rules"
          ref="addAlterForm"
        >
          <el-form-item label="账号" prop="account" label-width="13rem">
            <el-input
              v-model="dialog.elForm.account"
              maxlength="20"
              placeholder="请输入账号"
            ></el-input>
            <span class="remark_span"></span>
          </el-form-item>
          <el-form-item label="旧密码" prop="usedPass" label-width="13rem">
            <el-input
              v-model="dialog.elForm.usedPass"
              maxlength="20"
              show-password
              placeholder="请输入旧密码"
            ></el-input>
            <span class="remark_span"></span>
          </el-form-item>
          <el-form-item label="新密码" prop="newPass1" label-width="13rem">
            <el-input
              v-model="dialog.elForm.newPass1"
              maxlength="20"
              show-password
              placeholder="请输入新密码"
            ></el-input>
            <span class="remark_span"></span>
          </el-form-item>
          <el-form-item label="确认新密码" prop="newPass2" label-width="13rem">
            <el-input
              v-model="dialog.elForm.newPass2"
              maxlength="20"
              show-password
              placeholder="再次输入新密码"
            ></el-input>
            <span class="remark_span"></span>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog_footer">
        <button class="button_style0" @click="dialogVisible = false">
          <i class="iconfont icon-quxiao1"></i>取消
        </button>
        <button
          v-if="dialog.openType != 0"
          class="button_style0"
          @click="submitClick('addAlterForm')"
        >
          <i class="iconfont icon-tijiao"></i>确认
        </button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import myApi from "../../util/my-api";
import myConst from "../../util/my-const";
export default {
  data() {
    let isPassConsistent = (rule, value, callback) => {
      if (this.dialog.elForm.newPass1 != this.dialog.elForm.newPass2) {
        return callback(new Error("两次输入新密码不一致"));
      }
      callback();
    };
    return {
      roleName: "",
      account: "",
      dialogVisible: false,
      dialog: {
        title: "修改密码",
        elForm: {
          account: "",
          usedPass: "",
          newPass1: "",
          newPass2: "",
        },
        rules: {
          account: [{ required: true, message: "请输入账号", trigger: "blur" }],
          usedPass: [
            { required: true, message: "请输入旧密码", trigger: "blur" },
          ],
          newPass1: [
            { required: true, message: "请输入新密码", trigger: "blur" },
          ],
          newPass2: [
            { required: true, message: "请再次输入新密码", trigger: "blur" },
            { validator: isPassConsistent, trigger: "blur" },
          ],
        },
      },
    };
  },
  created() {
    this.selectUserInfo();
  },
  methods: {
    selectUserInfo() {
      let _this = this;
      this.$axios
        .get(myApi.getUserInfo)
        .then((res) => {
          if (res.data.code === myConst.code.success) {
            _this.roleName = res.data.data.roleName;
            _this.account =
              res.data.data.fullName.trim() === ""
                ? res.data.data.account
                : res.data.data.fullName.trim();
          } else {
          }
        })
        .catch(() => {});
    },
    alterPassClick() {
      this.dialogVisible = true;
    },
    submitClick(formName) {
      let _this = this;
      this.$refs[formName].validate((valid) => {
        //校验输入值
        if (valid) {
          _this
            .$confirm("确认要修改密码吗？", "提示", {
              confirmButtonText: "确认",
              cancelButtonText: "取消",
            })
            .then(() => {
              //执行修改操作
              _this.$axios
                .post(myApi.alterPass, _this.dialog.elForm)
                .then((res) => {
                  if (res.data.code === myConst.code.success) {
                    this.$message({
                      showClose: true,
                      message: res.data.msg,
                      type: "success",
                    });
                  } else {
                    // this.$message({showClose: true, message: res.data.msg, type: 'info'});
                  }
                });
            })
            .catch(() => {});
        }
      });
    },
    handleDialogClosed() {
      this.$emit("closePopup", false);
      // console.log("关闭了弹窗");
    },
  },
};
</script>

<style scoped>
.dialog_content {
  height: auto;
}
/*输入框后面文字备注*/
.remark_span {
  float: left;
}

/*弹出框右侧输入框*/
.dialog_content .el-select,
.dialog_content .el-input,
.dialog_content .el-textarea {
  float: left;
}

.dialog_footer button {
  margin-right: 0rem;
}
::v-deep .el-dialog {
  height: auto;
}
.dialog_title {
  margin-top: -0.5rem;
}
.dialog_footer {
  margin: 5rem 0;
}
</style>
